import axios from "axios";
import { message } from "antd";

const url = process.env.REACT_APP_API_KEY; 

// headers: {'Content-Type': 'multipart/form-data;'}

export const userLogin = (body, onSuccess, onFail) => {
    const headers = {
      "Content-Type": "application/json",
      "content-language": `${localStorage.getItem("lang") || "en"}`,  
      "deviceId": localStorage.getItem("deviceId"),  
    };
    axios({ 
      method: 'post',
      url: `${url}CustomerLogin`,
      data: body,
      headers
      })
      .then((response) => {
          return onSuccess(response);
      }) 
      .catch(err => onFail(err.response.data.errors)); 
}


export const RegisterCustomer = (body, onSuccess, onFail) => {
        const headers = {
      "Content-Type": "application/json",
      "content-language": `${localStorage.getItem("lang") || "en"}`,  
    };
    // if(localStorage.getItem("tokenCi")){
    //   headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`
    // } 
    axios({ 
        method: 'post',
        url: `${url}RegisterCustomer`,
        data: body,
        headers 
        })
        .then(response => onSuccess(response)) 
        .catch(err => onFail(err.response.data.errors)); 
}

export const verifyCode = (body, onSuccess, onFail) => {
        const headers = {
      "Content-Type": "application/json",
      "content-language": `${localStorage.getItem("lang") || "en"}`,  
    };
    if(localStorage.getItem("tokenCi")){
      headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`
    }
    if(localStorage.getItem("deviceId")){
      if(!!!localStorage.getItem("tokenCi")){
        headers.deviceId = localStorage.getItem("deviceId") 
      }
    }
    axios({ 
        method: 'post',
        url: `${url}verify/code`,
        data: body,
        headers: {'Content-Type': 'multipart/form-data;'}
        })
        .then((response) => {
            if (response.data.validation.length > 0) { 
                response.data.validation.forEach(element => {
                    message.error(element); 
                });
            }
            return onSuccess(response);
        }) 
        .catch(err => onFail(err)); 
}

export const resendVerificationCode = (body, onSuccess, onFail) => {
        const headers = {
      "Content-Type": "application/json",
      "content-language": `${localStorage.getItem("lang") || "en"}`,  
    };
    if(localStorage.getItem("tokenCi")){
      headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`
    }
    if(localStorage.getItem("deviceId")){
      if(!!!localStorage.getItem("tokenCi")){
        headers.deviceId = localStorage.getItem("deviceId") 
      }
    }
    axios({ 
        method: 'post',
        url: `${url}resend/code`, 
        data: body,
        headers: {'Content-Type': 'multipart/form-data;'}
        })
        .then((response) => {
            if (response.data.validation.length > 0) { 
                response.data.validation.forEach(element => {
                    message.error(element); 
                });
            }
            return onSuccess(response);
        }) 
        .catch(err => onFail(err)); 
}

export const userLogout = (onSuccess , onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,  
  };
  if(localStorage.getItem("tokenCi")){
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`
  }
  else if(localStorage.getItem("deviceId")){
      headers.deviceId = localStorage.getItem("deviceId") 
  }
  axios({ 
    method: 'get',
    url: `${url}CustomerLogout`,
    data:{},
    headers
    })
    .then((response) => {
      message.success(".تم تسجيل الخروج بنجاح")
      return onSuccess(response)
    }) 
    .catch(err => onFail(err)); 
}

export const forgetPassword = (email, onSuccess, onFail) =>{
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
    "deviceId": localStorage.getItem("deviceId"),
  };
  axios({ 
    method: 'get',
    url: `${url}ForgetPassword?Email=${email}`,
    headers
    })
    .then((response) => {
      onSuccess(response)
    }) 
    .catch(err => onFail(err)); 
}

export const CheckForgetPasswordCode = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
    "deviceId": localStorage.getItem("deviceId"),
  };
  axios({
    method: 'post',
    url: `${url}CheckForgetPasswordCode`,
    data: body,
    headers
    })
    .then((response) => {
      onSuccess(response)
    }) 
    .catch(err => onFail(err)); 
}

export const resetPassword = (body, onSuccess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
    "deviceId": localStorage.getItem("deviceId"),
  };
  axios({
    method: 'post',
    url: `${url}ResetPassword`,
    data: body,
    headers
    })
    .then((response) => onSuccess(response))
    .catch(err => onFail(err))
}

export const verifyEmail = (body,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
    "deviceId": localStorage.getItem("deviceId"),
  };
  axios({ 
    method: 'post',
    url: `${url}VerifyEmail`,
    data:body,
    headers
    })
    .then((response) => {
      onSuccess(response)
    }) 
    .catch(err => onFail(err)); 
}

export const senVerificationEmailCode = (email,onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
    "deviceId": localStorage.getItem("deviceId"),
  };
  axios({ 
    method: 'get',
    url: `${url}SendVerificationCode?Email=${email}`,
    headers
    })
    .then((response) => {
      onSuccess(response)
    }) 
    .catch(err => onFail(err)); 
}